import { Fragment } from "react";

export const AddOnServices = (props) => {
  const { branding, bookingDetails } = props;
  return (
    <Fragment>
      <h3
        className="mt-4"
        style={{
          color: branding.headingColor,
          fontFamily: branding.headingFont,
        }}
      >
        Add-On Services
      </h3>
      {bookingDetails.addonServices.length > 0 ? (
        <div
          style={{
            marginTop: "20px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            overflow: "hidden",
            backgroundColor: "#f8f8f8",
          }}
        >
          <table className="table">
            <thead>
              <tr>
                <th>Service Name</th>
                <th>Description</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {bookingDetails.addonServices.map((service, index) => (
                <tr key={index}>
                  <td>{service.serviceName}</td>
                  <td>{service.serviceDescription || "N/A"}</td>
                  <td>{service.servicePrice.toLocaleString()} VND</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No add-on services selected.</p>
      )}
    </Fragment>
  );
};
